import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import _AdminService from 'modules/AdminService';
import { Col, Row, Table, DatePicker as DatePickerAntd, } from 'antd';
import PageHeader from 'components/enterprise/PageHeader';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import MyInput from 'components/controls/MyInput';
import DropdownList from 'components/controls/DropdownList';
import ButtonComponent from 'components/controls/Button';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import _utils from '../../modules/Utils';
import moment from 'moment';
// import 'jspdf-autotable';

import { NEW_ATTENDANCE_SHEET_HEADER } from "../../constants/constants"
import { routesAdmin } from "../../routes/Routes";

class NewAttendanceSheet extends Component {
    constructor(props) {
            super(props);
            this.state = {
                post: "",
                postName: "",
                exams: [],
                timings: [
                    { Name: "9 AM TO 10:30 AM", Id: "9 AM TO 10:30 AM" },
                    { Name: "10 AM TO 11:30 AM", Id: "10 AM TO 11:30 AM" },
                    { Name: "11:30 AM TO 1 PM", Id: "11:30 AM TO 1 PM" },
                    { Name: "1 PM TO 2:30 PM", Id: "1 PM TO 2:30 PM" },
                    { Name: "2 PM TO 3:30 PM", Id: "2 PM TO 3:30 PM" },
                    { Name: "4 PM TO 5:30 PM", Id: "4 PM TO 5:30 PM" },
                    { Name: "4:30 PM TO 6 PM", Id: "4:30 PM TO 6 PM" },
                    { Name: "Other", Id: "Other" },
                ],
    
                center: "",
                building: "",
                floor: "",
                roomNo: "",
                batchNo: "",
                date: "",
                timing: "",
                maxRollNumber: "",
                minRollNumber: "",
                otherTiming: "",
    
    
                centerError: "",
                buildingError: "",
                floorError: "",
                roomNoError: "",
                batchNoError: "",
                dateError: "",
                timingError: "",
                maxRollNumberError: "",
                minRollNumberError: "",
                postError: "",
                otherTimingError: "",
    
                candidateData: [],
                totalCandidate: 0,
                isLoading: true,
                fieldDisable: false,
    
                newAttendanceSheetHeader: NEW_ATTENDANCE_SHEET_HEADER,
    
                tableColumns: [
                    {
                        title: 'Sr.No',
                        dataIndex: 'id',
                        width: '5%',
                        key: 'serialNumber',
                        render: (_, record, index) => {
                            // Flatten candidateData into a single array
                            const flattenedArray = this.state.candidateData 
                                ? this.state.candidateData.flat() 
                                : [];
                        
                            const rowIndex = flattenedArray.indexOf(record) + 1;
                        
                            return <div>{rowIndex}</div>;
                        },                    
                    },
                    {
                        title: 'Roll Number',
                        dataIndex: 'RoleNumebr',
                        width: '10%',
                        key: 'RoleNumebr',
                        sorter: (a, b) => a.RoleNumebr > b.RoleNumebr
                    },
                    {
                        title: 'Full Name',
                        dataIndex: 'candidateName',
                        width: '30%',
                        key: 'candidateName',
                    },
                    {
                        title: 'Profile Picture',
                        dataIndex: 'Profile_Pic_Path',
                        width: '10%',
                        key: 'Profile_Pic_Path',
                        render: (text, record) => (
                            <img
                                src={record.Profile_Pic_PathBase}
                                // src={_utils.getBlobFullURL(record.Profile_Pic_Path)}
                                alt="Profile"
                                style={{ height: '100px', objectFit: 'cover' }}
                            />
                        )
                    },
                    {
                        title: 'Signature Path',
                        dataIndex: 'Signature_Path',
                        width: '15%',
                        key: 'Signature_Path',
                        render: (text, record) => (
                            <img
                                src={record.Signature_PathBase}
                                // src={_utils.getBlobFullURL(record.Signature_Path)}
                                alt="Signature"
                                style={{ width: '200px', height: '100px', objectFit: 'cover' }}
                            />
                        )
                    },
                    {
                        title: 'Candidate Signature',
                        dataIndex: 'candidateSignature',
                        width: '15%',
                    }
                ]
    
            };
            this.tableRefs = []; // Create a ref for the table
    
        }

    onDateChange = ({ target: { name, value } }) => {
        
        this.setState({
            [name]: value,
        });
    };

    componentDidMount() {
        this.getAllExams();
    }

    getAllExams = async () => {
        try {
            this.setState({ isLoading: true }, async () => {
                try {
                    let examsList = await _AdminService.GetAllPost();

                    this.setState({
                        ...this.state,
                        exams: examsList.data,
                        isLoading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ isLoading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }


    onPostChange = (event) => {
        /* eslint-disable no-debugger, no-console */ 
        let post = event.target.value;
        let postName = ""
        console.log("this.state.exams", this.state.exams);
        for (let i = 0; this.state.exams.length > i; i++) {
            console.log(this.state.exams[i].Id)
            if (post === this.state.exams[i].Id.toString()) {
                // alert(this.state.exams[i].Name)
                let text = this.state.exams[i].Name;
                // const myArray = text.split(" ");
                // console.log("myArray", myArray);
                postName = text;
            }
        }
        this.setState({
            ...this.state,
            post: post,
            postName: postName
        });
    }
    
    onTimingChange = (event) => {
        const timingId = event.target.value;
        let timingName = "";


        if (timingId === "Other") {
            timingName = "";
        } else {

            for (let i = 0; i < this.state.timings.length; i++) {
                if (timingId === this.state.timings[i].Id) {
                    timingName = this.state.timings[i].Name;
                    break;
                }
            }
        }
        
        this.setState({
            timing: timingId,
            otherTiming: timingId === "Other" ? this.state.otherTiming : "",

        });
    };


    onOtherTimingChange = (event) => {
        const customTime = event.target.value;

        this.setState({
            otherTiming: customTime,
        });
    };
    
    onTextChange = ({ target: { name, value } }) => {
        console.log(name, value);

        const re = /^[0-9\b]+$/;

        switch (name) {
            case 'center':
            case 'building':
            case 'floor':
            case 'roomNo':
            case 'batchNo':
            case 'date':
            case 'timing':

                this.setState({
                    [name]: value,
                });
                break;

            case 'minRollNumber':
            case 'maxRollNumber':
                
                if (value === "" || re.test(value)) {
                    this.setState({
                        [name]: value,
                    });
                }
                break;

            default:

                this.setState({
                    [name]: value,
                });
                break;
        }
    };

    submit = () => {
        let flag = true;

        if (this.state.timing === "") {
            flag = false;
            this.setState({
                timingError: "timing cannot be empty.",
            });
        } else if (this.state.timing === "Other") {
            this.setState({
                timingError: " ",
            });
        }

        if (this.state.timing === "Other" && this.state.otherTiming === "") {
            flag = false;
            this.setState({
                otherTimingError: "timing cannot be empty.",
            });
        }

        if (this.state.center === "") {
            flag = false;
            this.setState({
                centerError: "Center can not be empty."
            })
        }

        if (this.state.building === "") {
            flag = false;
            this.setState({
                buildingError: "Bulding can not be empty."
            })
        }

        if (this.state.floor === "") {
            flag = false;
            this.setState({
                floorError: "Floor can not be empty."
            })
        }

        if (this.state.roomNo === "") {
            flag = false;
            this.setState({
                roomNoError: "Room number can not be empty."
            })
        }

        if (this.state.batchNo === "") {
            flag = false;
            this.setState({
                batchNoError: "Batch number can not be empty."
            })
        }

        if (this.state.date === "") {
            flag = false;
            this.setState({
                dateError: "Date can not be empty."
            })
        }

        if (this.state.timing === "") {
            flag = false;
            this.setState({
                timingError: "Timing can not be empty."
            })
        }

        if (this.state.minRollNumber === "") {
            flag = false;
            this.setState({
                minRollNumberError: "Start roll number can not be empty."
            })
        }

        if (this.state.maxRollNumber === "") {
            flag = false;
            this.setState({
                maxRollNumberError: "End roll number can not be empty."
            })
        }

        const re = /^[0-9\b]+$/;

        if (!re.test(this.state.minRollNumber)) {
            flag = false;
            this.setState({
                minRollNumberError: "Start roll number should be number only."
            })
        }

        if (!re.test(this.state.maxRollNumber)) {
            flag = false;
            this.setState({
                maxRollNumberError: "End roll number should be number only."
            })
        }

        if (this.state.post === 0 || this.state.post === "") {
            flag = false;
            this.setState({
                postError: "Select proper post."
            })
        }

            // Validate roll numbers
        if (this.state.minRollNumber > this.state.maxRollNumber) {
            this.setState({
                minRollNumberError:"Start roll number should not be greater than end roll number.",
                maxRollNumberError:"End roll number should not be smaller than start roll number."

            })
        }

        if (flag) {

            try {
                this.setState({ isLoading: true }, async () => {
                    try {
                        let response = await _AdminService.GetStudentDataForAttendance(this.state.minRollNumber, this.state.maxRollNumber);
                        // console.log("Post Data: ", response.data);

                        // let candidatesTemp = response.data.Obj.concat(response.data.Obj);
                        // let candidates1 = candidatesTemp.concat(candidatesTemp);
                        // let candidates2 = candidates1.concat(candidates1);
                        // let candidates = candidates2.concat(candidates1);

                        let candidates = response.data.Obj;
                        const updatedCandidates = candidates.map(candidate => ({
                            ...candidate,   // Spread the existing fields
                            candidateSignature: "",  // Add candidateSignature field
                            candidateName: `${candidate.Firstname || ''} ${candidate.MiddleName || ''} ${candidate.LastName || ''}`.trim()

                        }));


                        const candidateDataChunk = [];
                        const firstChunkSize = 16;
                        const subsequentChunkSize = 20;

                        // Process the first chunk
                        if (updatedCandidates.length > 0) {
                            const firstChunk = updatedCandidates.slice(0, firstChunkSize);
                            candidateDataChunk.push(firstChunk);
                        }

                        // Process the subsequent chunks
                        for (let i = firstChunkSize; i < updatedCandidates.length; i += subsequentChunkSize) {
                            const chunk = updatedCandidates.slice(i, i + subsequentChunkSize);
                            candidateDataChunk.push(chunk);
                        }

                        for (let k = 0; candidateDataChunk.length > k; k++) {
                            this.tableRefs[k] = React.createRef(); // Initialize each ref
                        }

                        this.setState({ fieldDisable: true, candidateData: candidateDataChunk, isLoading: false, totalCandidate: updatedCandidates.length });

                    } catch (e) {
                        // TODO
                        this.setState({ isLoading: false });
                        console.log('Error: ', e);
                    }
                });
            } catch (e) { }
        }
    }

    // generatePDF = async () => {
    //     const pdf = new jsPDF('p', 'mm', 'a4');
    //     const padding = 15;
    //     const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * padding;
    //     const pageHeight = pdf.internal.pageSize.getHeight() - 2 * padding;
    //     let retryCount = 0;
    //     const maxRetries = 2;

    //     const attemptToGeneratePDF = async () => {
    //         try {
    //             for (let i = 0; i < this.tableRefs.length; i++) {
    //                 const ref = this.tableRefs[i];

    //                 try {
    //                     // Capture each table one by one
    //                     const canvas = await html2canvas(ref.current, { scale: 2 });
    //                     const imgData = canvas.toDataURL('image/jpeg', 1.0);

    //                     const imgHeight = (canvas.height * pdfWidth) / canvas.width;
    //                     let heightLeft = imgHeight;
    //                     let position = padding;

    //                     // Add the first image
    //                     pdf.addImage(imgData, 'JPEG', padding, position, pdfWidth, imgHeight, '', 'NONE');
    //                     heightLeft -= pageHeight;

    //                     // Add additional pages if needed
    //                     while (heightLeft > 0) {
    //                         pdf.addPage();
    //                         position = heightLeft - imgHeight + padding;
    //                         pdf.addImage(imgData, 'JPEG', padding, position, pdfWidth, imgHeight, '', 'NONE');
    //                         heightLeft -= pageHeight;
    //                     }

    //                     // Add a new page for the next table if it exists
    //                     if (i < this.tableRefs.length - 1) {
    //                         pdf.addPage();
    //                     }

    //                     // Manually clear the canvas to free up memory
    //                     canvas.remove();

    //                 } catch (canvasError) {
    //                     console.error(`Error capturing or adding image for table ${i + 1}:`, canvasError);
    //                     throw new Error("Error capturing table image.");
    //                 }
    //             }

    //             const pdfFileName = `${this.state.postName}_${this.state.center}_${this.state.building}_${this.state.floor}_${this.state.roomNo}_${this.state.batchNo}_${this.state.minRollNumber}-${this.state.maxRollNumber}.pdf`;

    //             try {
    //                 // Save the PDF after processing all tables
    //                 pdf.save(pdfFileName);
    //                 this.setState({
    //                     isLoading: false
    //                 })
    //             } catch (saveError) {
    //                 console.error("Error saving PDF file:", saveError);
    //                 throw new Error("Failed to save PDF.");
    //             }

    //         } catch (error) {
    //             console.log("Attempt", retryCount + 1, "failed:", error);

    //             // Retry if the maxRetries count has not been reached
    //             if (retryCount < maxRetries) {
    //                 retryCount++;
    //                 await attemptToGeneratePDF();
    //             } else {
    //                 console.error("Failed to generate PDF after multiple attempts.");
    //                 alert("Failed to generate PDF. Please try again later.");
    //             }
    //         }
    //     };

    //     // Start the PDF generation with retries
    //     await attemptToGeneratePDF();
    // };

    generatePDF = async () => {
        /* eslint-disable no-debugger, no-console */ 
        //const doc = new jsPDF();

        const doc = new jsPDF({
            compress: true, // Enable internal compression
        });

        // Set header font size and add the header
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");

        const postEngTxt = this.state.postName && this.state.postName.split(" ");

        // Add details at the top
        const details = [
            { label: "Building", value: this.state.building },
            { label: "Room Number", value: this.state.roomNo },
            { label: "Date", value: this.state.date },
            { label: "Start Roll Number", value: this.state.minRollNumber },
            { label: "Post Name", value: postEngTxt[0] },
            { label: "Floor", value: this.state.floor },
            { label: "Batch Number", value: this.state.batchNo },
            { label: "Timing", value: _utils.formatTimeAttendanceSheetData(this.state.timing) },
            { label: "End Roll Number", value: this.state.maxRollNumber },
        ];

        const xLeft = 10;
        const xRight = 50;
        let yPos = 37;
        const lineHeight = 9;
        const boxWidth = 100;
        const boxHeight = 10;

        // Left column
        doc.setLineWidth(0.1);
        doc.rect(5, 8, 200, 70);
        doc.setFont("helvetica", "bold");
        
        // Define the maximum width for the text within the header box
        const maxWidth = 190; // Slightly less than the box width for padding

        // Split the text to fit within the specified width
        const headerText = doc.splitTextToSize(this.state.newAttendanceSheetHeader, maxWidth);

        // Dynamically position the text to fit inside the header box
        let yPosition = 15; // Starting y position for the text
        headerText.forEach((line) => {
            doc.text(line, 10, yPosition, { align: "left" }); // Adjust x as needed
            yPosition += 5; // Increment y for the next line
        });



        doc.setFont("helvetica", "normal");
        const X = 10;
        const Y = 27;
        doc.text("Center: " + this.state.center, X ,Y);

        details.slice(0, 5).forEach((item) => {
            doc.text(`${item.label}: ${item.value}`, xLeft, yPos);
            yPos += lineHeight;
        });

        // Right column
        yPos = 37;
        details.slice(5, 9).forEach((item) => {
            doc.text(`${item.label}: ${item.value}`, 120, yPos);
            yPos += lineHeight;
        });

        const combinedArray = this.state.candidateData
            ? this.state.candidateData.flat()
            : [];

        // Create the table with static data and base64 images in the Profile_Pic_Path column (index 3)
        doc.autoTable({

            head: [['Sr.No', 'Roll Number', 'Full Name', 'Profile Picture', 'Signature Path', 'Candidate Signature']],
            body: combinedArray && combinedArray.map((item, index) => [
                index + 1,
                item.RoleNumebr,
               `${item.Firstname} ${item.MiddleName} ${item.LastName}`.trim(),
            ]),
            didDrawCell: (data) => {
                if (data.section == "body") {

                    const pageHeight = doc.internal.pageSize.height;
                    const availableHeight = pageHeight - (data.cell.y + data.cell.styles.minCellHeight);

                    if (availableHeight < 0) {
                        data.cell.styles.minCellHeight = pageHeight - data.cell.y - 10; // Fit within remaining space
                    }

                    if (data.column.index === 3 && data.row.index >= 0) {
                        const imageData = combinedArray && combinedArray[data.row.index].Profile_Pic_PathBase;

                        try {
                            doc.addImage(imageData, 'jpg', data.cell.x + 5, data.cell.y + 2, 17, 18);
                        } catch (error) {
                            const defaultImage = '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'; // Replace with your default image in base64 format
                            doc.addImage(defaultImage, 'jpg', data.cell.x + 5, data.cell.y + 2, 17, 18);
                        }

                    } else if (data.column.index === 4 && data.row.index >= 0) {
                        const imageData = combinedArray && combinedArray[data.row.index].Signature_PathBase;
                        try {
                            doc.addImage(imageData, 'jpg', data.cell.x + 5, data.cell.y + 2, 17, 18);
                        } catch (error) {
                            const defaultImage = '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'; // Replace with your default image in base64 format
                            doc.addImage(defaultImage, 'png', data.cell.x + 5, data.cell.y + 2, 17, 18);
                        }

                    }
                }
            },
            columnStyles: {
                0: { cellWidth: 15 },
                1: { cellWidth: 25 },
                2: { cellWidth: 65 },
                3: { cellWidth: 25 },
                4: { cellWidth: 35 },
                5: { cellWidth: 35 }
            },
            headStyles: {
                fillColor: [255, 255, 255],
                textColor: [0, 0, 0],
                lineWidth: 0.1,
                lineColor: [0, 0, 0],
                minCellHeight: 8, // Adjusted header height
                cellPadding: 2,
            },

            styles: {
                font: 'helvetica',
                fontSize: 10,
                textColor: [0, 0, 0],
                cellPadding: 2,
                lineWidth: 0.1,
                minCellHeight: 22,

                lineColor: [0, 0, 0],
                fillColor: [255, 255, 255], // White background for all cells
            },

            rowPageBreak: 'avoid',
            alternateRowStyles: {
                fillColor: [255, 255, 255]
            },
            startY: 85,
            margin: {  left: 5, right: 5},

        });


        let tableFinalY = doc.lastAutoTable.finalY + 10;
        
        // Invigilator Details Section
        let invigilatorTableY = doc.lastAutoTable.finalY + 15; // Adjust starting position
        const tableX = 5; // Starting X position
        const tableWidth = 110; // Total table width
        const cellHeight = 10; // Height of each row
        
        /////////
        const pageHeight1 = doc.internal.pageSize.height;

        const remainingSpace = pageHeight1 - tableFinalY;
        const requiredSpace = cellHeight * 3 + 10; // Height of the invigilator table plus some margin

        if (remainingSpace < requiredSpace) {
            doc.addPage(); // Add a new page if there's insufficient space
            invigilatorTableY = 10; // Reset the Y position for the new page
            tableFinalY = 10;
        }
        //////
        
        // Draw the outer rectangle
        doc.setDrawColor(0, 0, 0); // Set border color to red
        doc.rect(tableX, invigilatorTableY, tableWidth, cellHeight * 3);

        // Draw horizontal lines for rows
        doc.line(tableX, invigilatorTableY + cellHeight, tableX + tableWidth, invigilatorTableY + cellHeight);
        doc.line(tableX, invigilatorTableY + cellHeight * 2, tableX + tableWidth, invigilatorTableY + cellHeight * 2);

        // Draw vertical line for columns
        const columnSplitX = tableX + (tableWidth / 2.3);
        doc.line(columnSplitX, invigilatorTableY, columnSplitX, invigilatorTableY + cellHeight * 3);

        // Add text to the table
        doc.setFontSize(10);
        doc.text("Invigilator's Name:", tableX + 5, invigilatorTableY + 7); // First row
        doc.text("Invigilator's Number:", tableX + 5, invigilatorTableY + cellHeight + 7); // Second row
        doc.text("Invigilator's Signature:", tableX + 5, invigilatorTableY + cellHeight * 2 + 7); // Third row


        // // Add Invigilator's Name section
        // doc.text("Invigilator's Name:", 10, tableFinalY + 11);

        // // Adjust gap for spacing
        // let gap = 3; // Adjust this value as needed
        // let nextSectionY = tableFinalY + 5 + gap;

        // // Add Invigilator's Number section
        // doc.text("Invigilator's Number:", 10, nextSectionY + 11);

        // // Adjust gap for signature section
        // gap = 8; // Adjust this value as needed
        // nextSectionY += gap;

        // // Add Invigilator's Signature section
        // doc.text("Invigilator's Signature:", 10, nextSectionY + 11);

        // Create a box for Present, Absent, and Total
        doc.rect(130, tableFinalY + 5, 75, 25);
        doc.text("Present", 135, tableFinalY + 11);
        doc.text("Absent", 160, tableFinalY + 11);
        doc.text("Total", 185, tableFinalY + 11);

        doc.line(130, tableFinalY + 14, 205, tableFinalY + 14);

        doc.line(155, tableFinalY + 5, 155, tableFinalY + 30);
        doc.line(180, tableFinalY + 5, 180, tableFinalY + 30);


        const pdfFileName = `${this.state.postName}_${this.state.center}_${this.state.building}_${this.state.floor}_${this.state.roomNo}_${this.state.batchNo}_${this.state.minRollNumber}-${this.state.maxRollNumber}.pdf`;
        // Save the PDF
        doc.save(pdfFileName);
    }

    footerTableHtml = () => {
        return (
            <Row style={{ marginTop: "20px", marginBottom: "20px" }}>
                <Col span={8}>
                    <table style={{ borderCollapse: "collapse", width: "100%", }} className="table-striped-candidate-data-rows">
                        <tbody>
                            <tr>
                                <td style={{ border: "1px solid  gray", width: "150px", fontSize: "20px", color: "black", textAlign: "center" }}>Invigilator’s Name:</td>
                                <td style={{ border: "1px solid  gray", width: "150px", fontSize: "20px", color: "black", textAlign: "center", height: "50px" }}></td>
                            </tr>

                            <tr>
                                <td style={{ border: "1px solid  gray", width: "150px", fontSize: "20px", color: "black", textAlign: "center" }}>Invigilator’s Number:</td>
                                <td style={{ border: "1px solid  gray", width: "150px", fontSize: "20px", color: "black", textAlign: "center", height: "50px" }}></td>
                            </tr>

                            <tr>
                                <td style={{ border: "1px solid  gray", width: "150px", fontSize: "20px", color: "black", textAlign: "center" }}>Invigilator’s Signature</td>
                                <td style={{ border: "1px solid  gray", width: "150px", fontSize: "20px", color: "black", textAlign: "center", height: "50px" }}></td>
                            </tr>
                        </tbody>
                    </table>
                </Col>
                <Col span={9}></Col>
                <Col span={7}>
                    <table style={{ borderCollapse: "collapse", width: "100%"}} className="table-striped-candidate-data-rows">
                        <thead>
                            <tr>
                                <th style={{ border: "1px solid  gray", width: "150px", fontSize: "20px", color: "black", textAlign: "center" }}>Present</th>
                                <th style={{ border: "1px solid  gray", width: "150px", fontSize: "20px", color: "black", textAlign: "center" }}>Absent</th>
                                <th style={{ border: "1px solid  gray", width: "150px", fontSize: "20px", color: "black", textAlign: "center" }}>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ border: "1px solid  gray", width: "150px", fontSize: "20px", color: "black", textAlign: "center", height: "50px" }}></td>
                                <td style={{ border: "1px solid  gray", width: "150px", fontSize: "20px", color: "black", textAlign: "center", height: "50px" }}></td>
                                <td style={{ border: "1px solid  gray", width: "150px", fontSize: "20px", color: "black", textAlign: "center", height: "50px" }}></td>
                            </tr>
                        </tbody>
                    </table>

                </Col>
            </Row>
        )
    }

    mainTableHtml = (dataSource) => {
        return (
            <Row className='' style={{ fontSize: "20px", color: "black" }}>
                <div className="max1200 m-auto">
                    <Table size='small'
                        bordered
                        rowKey='Id'
                        columns={this.state.tableColumns}
                        dataSource={dataSource}
                        className="table-striped-candidate-data-rows table-striped-rows admin-table"
                        pagination={false}
                    />
                </div>
            </Row>
        )
    }

    headerHtml = () => {
        return (
          <>
            <Row
              style={{
                paddingLeft: "20px",
                paddingBottom: "20px",
                borderRight: "1px solid  gray",
                borderLeft: "1px solid  gray",
                borderTop: "1px solid  gray",
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "4px",
              }}
            >
              <Col span={24}>
                <label
                  style={{
                    fontSize: "32px",
                    fontWeight: "600",
                    color: "black",
                  }}
                >
                  {this.state.newAttendanceSheetHeader}
                </label>
              </Col>
            </Row>
            <Row
              style={{
                paddingLeft: "20px",
                paddingBottom: "20px",
                paddingRight: "20px",
                borderRight: "1px solid  gray",
                borderLeft: "1px solid  gray",
              }}
            >
              <Col span={16} style={{ paddingRight: "53px", display: "flex" }}>
                <label
                  htmlFor="center"
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                    marginRight: "5px",
                  }}
                >
                  Center:{" "}
                </label>
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                  }}
                >
                  {this.state.center}
                </label>
              </Col>
            </Row>
            <Row
              style={{
                paddingLeft: "20px",
                paddingBottom: "20px",
                paddingRight: "20px",
                borderRight: "1px solid  gray",
                borderLeft: "1px solid  gray",
              }}
            >
              <Col span={8} style={{ display: "flex" }}>
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                    marginRight: "5px",
                  }}
                  htmlFor="building"
                >
                  Building:{" "}
                </label>
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                  }}
                >
                  {this.state.building}
                </label>
              </Col>
              <Col span={7} style={{ display: "flex" }}>
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                    marginRight: "5px",
                  }}
                  htmlFor="floor"
                >
                  Floor:{" "}
                </label>
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                  }}
                >
                  {this.state.floor}
                </label>
              </Col>
              <Col
                span={8}
                style={{ display: "flex", justifyContent: "right" }}
              >
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                    marginRight: "5px",
                  }}
                  htmlFor="roomNo"
                >
                  Room Number:{" "}
                </label>
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                  }}
                >
                  {this.state.roomNo}
                </label>
              </Col>
            </Row>
            <Row
              style={{
                paddingLeft: "20px",
                paddingBottom: "20px",
                paddingRight: "20px",
                borderRight: "1px solid  gray",
                borderLeft: "1px solid  gray",
              }}
            >
              <Col span={8} style={{ display: "flex" }}>
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                    marginRight: "5px",
                  }}
                  htmlFor="batchNo"
                >
                  Batch Number:{" "}
                </label>
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                  }}
                >
                  {this.state.batchNo}
                </label>
              </Col>
              <Col span={7} style={{ display: "flex" }}>
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                    marginRight: "5px",
                  }}
                  htmlFor="date"
                >
                  Date:{" "}
                </label>
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                  }}
                >
                  {this.state.date}
                </label>
              </Col>
              <Col
                span={8}
                style={{ display: "flex", justifyContent: "right" }}
              >
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                    marginRight: "5px",
                  }}
                  htmlFor="timing"
                >
                  Timing:{" "}
                </label>
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                  }}
                >
                  {this.state.timing === "Other"
                    ? this.state.otherTiming
                    : this.state.timing}
                </label>
              </Col>
            </Row>

            <Row
              style={{
                marginBottom: "20px",
                paddingLeft: "20px",
                paddingBottom: "20px",
                paddingRight: "20px",
                borderRight: "1px solid  gray",
                borderLeft: "1px solid  gray",
                borderBottom: "1px solid  gray",
                borderBottomLeftRadius: "4px",
                borderBottomRightRadius: "4px",
              }}
            >
              <Col span={8} style={{ display: "flex" }}>
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                    marginRight: "5px",
                  }}
                  htmlFor="minRollNumber"
                >
                  Start Roll Number:{" "}
                </label>
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                  }}
                >
                  {this.state.minRollNumber}
                </label>
              </Col>
              <Col span={7} style={{ display: "flex" }}>
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                    marginRight: "5px",
                  }}
                  htmlFor="maxRollNumber"
                >
                  End Roll Number:{" "}
                </label>
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                  }}
                >
                  {this.state.maxRollNumber}
                </label>
              </Col>
              <Col
                span={8}
                style={{ display: "flex", justifyContent: "right" }}
              >
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                    marginRight: "5px",
                  }}
                  htmlFor="maxRollNumber"
                >
                  Post Name:{" "}
                </label>
                <label
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "black",
                  }}
                >
                  {this.state.postName}
                </label>
              </Col>
            </Row>
          </>
        );
    }

    clearFunction = () =>{
        this.setState({
            center:"",
            building:"",
            floor:"",
            roomNo:"",
            batchNo:"",
            date:"",
            timing:"",
            otherTiming:"",
            minRollNumber:"",
            maxRollNumber:"",
            post:"",

            timingError: "",
            otherTimingError: "",
            centerError: "",
            buildingError: "",
            floorError: "",
            roomNoError: "",
            batchNoError: "",
            dateError: "",
            maxRollNumberError: "",
            minRollNumberError: "",
            postError: "",

            candidateData: []
        })
    }

    onCancel = () => {
        return <Redirect to={{
            pathname: routesAdmin.dashboard.path
          }} />
    }

    render() {

        console.log("this.state", this.state)
        if (this.state.isLoading)
            return <LoadingSpinner />

        return (

            <div className="analysisWrap" style={{ alignItems: 'center' }}>
                <div className="container-fluid p-4">
                    <PageHeader
                        title="Attendance Sheet"
                        breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Attendance' }, { label: 'Attendance Sheet' }]}
                    />
                    <div className="max1200 m-auto">
                        <div className="ent-panel mb-3">
                            <div className="admin-inner-wrap p-3">
                                <Row gutter={[16, 16]} className="m-0">
                                    <Col span={24} >
                                        <label htmlFor="center">Center</label>
                                        <MyInput id="center"
                                            type="text"
                                            key="center"
                                            name="center"
                                            value={this.state.center ? this.state.center : ""}
                                            onChange={this.onTextChange}
                                            isRequired={false}
                                            errorState={this.state.centerError}
                                            errorMessage={this.state.centerError}
                                            placeholder="Center"
                                            // disabled={this.state.fieldDisable}
                                        />
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]} className="m-0">
                                    <Col span={8}>
                                        <label htmlFor="building">Building</label>
                                        <MyInput id="building"
                                            type="text"
                                            key="building"
                                            name="building"
                                            value={this.state.building ? this.state.building : ""}
                                            onChange={this.onTextChange}
                                            isRequired={false}
                                            errorState={this.state.buildingError}
                                            errorMessage={this.state.buildingError}
                                            placeholder="Building"
                                            // disabled={this.state.fieldDisable}
                                        />
                                    </Col>
                                    <Col span={8} >
                                        <label htmlFor="floor">Floor</label>
                                        <MyInput id="floor"
                                            type="text"
                                            key="floor"
                                            name="floor"
                                            value={this.state.floor ? this.state.floor : ""}
                                            onChange={this.onTextChange}
                                            isRequired={false}
                                            errorState={this.state.floorError}
                                            errorMessage={this.state.floorError}
                                            placeholder="Floor"
                                            // disabled={this.state.fieldDisable}
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <label htmlFor="roomNo">Room Number</label>
                                        <MyInput id="roomNo"
                                            type="text"
                                            key="roomNo"
                                            name="roomNo"
                                            value={this.state.roomNo ? this.state.roomNo : ""}
                                            onChange={this.onTextChange}
                                            isRequired={false}
                                            errorState={this.state.roomNoError}
                                            errorMessage={this.state.roomNoError}
                                            placeholder="Room Number"
                                            // disabled={this.state.fieldDisable}
                                        />
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]} className="m-0">
                                    <Col span={8}>
                                        <label htmlFor="batchNo">Batch Number</label>
                                        <MyInput id="batchNo"
                                            type="text"
                                            key="batchNo"
                                            name="batchNo"
                                            value={this.state.batchNo ? this.state.batchNo : ""}
                                            onChange={this.onTextChange}
                                            isRequired={false}
                                            errorState={this.state.batchNoError}
                                            errorMessage={this.state.batchNoError}
                                            placeholder="Batch Number"
                                            // disabled={this.state.fieldDisable}
                                        />
                                    </Col>
                                    <Col span={8} >
                                        <label htmlFor="date">Date</label>

                                        <MyInput id="date"
                                            type="text"
                                            key="date"
                                            name="date"
                                            value={this.state.date ? this.state.date : ""}
                                            onChange={this.onTextChange}
                                            isRequired={false}
                                            errorState={this.state.dateError}
                                            errorMessage={this.state.dateError}
                                            placeholder="Date"
                                            // disabled={this.state.fieldDisable}
                                        />
                                    </Col>
                                    <Col span={this.state.timing === "Other" ? 4 : 8}>
                                        <label htmlFor="timing">Timing</label>
                                        <select
                                            id="timing"
                                            name="timing"
                                            value={this.state.timing}
                                            onChange={this.onTimingChange}
                                            className="w-100"
                                            // disabled={this.state.fieldDisable}
                                        >
                                            <option value="">
                                                Select Timing
                                            </option>
                                            {this.state.timings.map((timingOption) => (
                                                <option key={timingOption.Id} value={timingOption.Id}>
                                                    {timingOption.Name}
                                                </option>
                                            ))}

                                        </select>
                                        {this.state.timingError && (
                                            <div style={{ color: "red", marginTop: "5px" }}>
                                                {this.state.timingError}
                                            </div>
                                        )}
                                    </Col>
                                    {/* Display input field for "Other" option */}
                                    {this.state.timing === "Other" && (
                                        <Col span={4}>
                                            <label htmlFor="otherTiming" style={{ visibility: "hidden" }}>
                                                Other Timing
                                            </label>
                                            <MyInput
                                                id="otherTiming"
                                                type="text"
                                                name="otherTiming"
                                                value={this.state.otherTiming}
                                                onChange={this.onOtherTimingChange}
                                                placeholder="Enter custom timing"
                                                className="w-100"
                                                style={{ marginTop: "0", marginLeft: "20px" }}
                                                // disabled={this.state.fieldDisable}
                                            />
                                            {this.state.otherTimingError && (
                                                <div style={{ color: "red", marginTop: "5px" }}>
                                                    {this.state.otherTimingError}
                                                </div>
                                            )}
                                        </Col>
                                    )}

                                </Row>

                                <Row  gutter={[16, 16]} className="m-0">
                                    <Col span={8}>
                                        <label htmlFor="minRollNumber">Start Roll Number</label>
                                        <MyInput id="minRollNumber"
                                            type="text"
                                            key="minRollNumber"
                                            name="minRollNumber"
                                            value={this.state.minRollNumber ? this.state.minRollNumber : ""}
                                            onChange={this.onTextChange}
                                            isRequired={false}
                                            errorState={this.state.minRollNumberError}
                                            errorMessage={this.state.minRollNumberError}
                                            placeholder="Start Roll Number"
                                            // disabled={this.state.fieldDisable}
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <label htmlFor="maxRollNumber">End Roll Number</label>
                                        <MyInput id="maxRollNumber"
                                            type="text"
                                            key="maxRollNumber"
                                            name="maxRollNumber"
                                            value={this.state.maxRollNumber ? this.state.maxRollNumber : ""}
                                            onChange={this.onTextChange}
                                            isRequired={false}
                                            errorState={this.state.maxRollNumberError}
                                            errorMessage={this.state.maxRollNumberError}
                                            placeholder="End Roll Number"
                                            // disabled={this.state.fieldDisable}
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <label>Select Post</label>
                                        <DropdownList
                                            value={this.state.post}
                                            name="ParentId"
                                            onChange={this.onPostChange}
                                            placeholder="Select Post"
                                            className="w-100"
                                            wrapClass="wrap"
                                            isRequired={true}
                                            options={this.state.exams}
                                            errorState={this.state.postError}
                                            errorMessage={this.state.postError}
                                            // isDisabled={this.state.fieldDisable}
                                        />
                                    </Col>
                                </Row>

                                
                            </div>
                            <div className="pt-4 buttonAlignCenter">
                                    <ButtonComponent
                                        id="btnPrint"
                                        type="button"
                                        value={<div className='displayInGrid'>Clear</div>}
                                        className="button-global button-secondary  autoHeight small mr-4"
                                        onClick={this.clearFunction} />
                                    <ButtonComponent
                                        id="btnPrint"
                                        type="button"
                                        value={<div className='displayInGrid'>Submit</div>}
                                        className="button-global button-primary autoHeight small"
                                        onClick={this.submit} />
                                    
                            </div>
                   
                        </div>   
                    </div>
                </div>

                {this.state.candidateData && this.state.candidateData.length > 0 &&
                    <div style={{ textAlign: 'center', border: 'solid', borderColor: 'gray', borderTop: "0px", borderBottom: "0px" }}>
                        <label style={{ fontSize: "24px", fontWeight: "600", color: "black", paddingTop: "12px", paddingBottom: "10px", margin: "0px" }}>{"Total Candidate"}{" - "}{this.state.totalCandidate}{" - "}{this.state.candidateData.length}</label>
                    </div>
                }

                {this.state.candidateData && this.state.candidateData.length > 0 &&
                    <div style={{ textAlign: 'center', border: 'solid', borderColor: 'gray' }}>
                        {this.state.candidateData && this.state.candidateData.length > 0 &&
                            this.state.candidateData.map((item, index) => {
                                // Example conditional rendering based on index
                                if (index === 0) {
                                    if (this.state.candidateData.length === 1) {
                                        // Render something specific for index 1
                                        return (
                                            <div ref={this.tableRefs[index]} key={index}>
                                                {/* Custom rendering for index 1 */}
                                                <div id="divReceiptPrint" style={{ textAlign: 'center', border: 'solid', borderColor: 'transparent', padding: 7 }}>
                                                    {this.headerHtml()}
                                                    {this.mainTableHtml(item)}
                                                    {this.footerTableHtml()}
                                                </div>
                                            </div>
                                        );
                                    }
                                    else {
                                        // Render something specific for index 1
                                        return (
                                            <div ref={this.tableRefs[index]} key={index}>
                                                <div className='mb-4'>
                                                    <div className="whiteBg gl-bxbr p-4 mb-4 max1200 m-auto cd-information">
                                                        <div className="admin-inner-wrap p-3">
                                                            <div className="container">
                                                                <div id="divReceiptPrint" style={{ textAlign: 'center', border: 'solid', borderColor: 'transparent', padding: 7 }}>
                                                                    {this.headerHtml()}
                                                                    {this.mainTableHtml(item)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* Custom rendering for index 1 */}
                                                
                                            </div>
                                        );
                                    }
                                }
                                else if (index === this.state.candidateData.length - 1) {
                                    return (
                                        <div ref={this.tableRefs[index]} key={index}>
                                            {/* Custom rendering for index 1 */}
                                            <div className='mb-4'>
                                                <div className="whiteBg gl-bxbr p-4 mb-4 max1200 m-auto cd-information">
                                                    <div className="admin-inner-wrap p-3">
                                                        <div className="container">
                                                                <div id="divReceiptPrint" style={{ textAlign: 'center', border: 'solid', borderColor: 'transparent', padding: 7 }}>
                                                                    {this.mainTableHtml(item)}
                                                                    {this.footerTableHtml()}
                                                                </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    )
                                } else {
                                    // Render default item for other indices
                                    return (
                                        <div ref={this.tableRefs[index]} key={index}>
                                            {/* Custom rendering for index 1 */}
                                            <div className='mb-4'>
                                                <div className="whiteBg gl-bxbr p-4 mb-4 max1200 m-auto cd-information">
                                                    <div className="admin-inner-wrap p-3">
                                                        <div className="container">
                                                            <div id="divReceiptPrint" style={{ textAlign: 'center', border: 'solid', borderColor: 'transparent', padding: 7 }}>
                                                                {this.mainTableHtml(item)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    );
                                }


                            })
                        }
                    </div>
                }

                {this.state.candidateData && this.state.candidateData.length > 0 &&
                    <div className="row">
                        <div className="col-12" style={{ "marginTop": "15px" }}>
                            <div className=" form-action d-flex justify-content-end">
                                <ButtonComponent
                                    id="btnCancel"
                                    type="button"
                                    value={<div className='displayInGrid'><div>Cancel</div><div>रद्द करा</div></div>}
                                    className="button-global button-secondary autoWidth autoHeight mr-3 autoHeight"
                                    onClick={this.onCancel} />

                                <ButtonComponent
                                    id="btnPrint"
                                    type="button"
                                    value={<div className='displayInGrid'><div>Download Candidate Attendance Data</div><div> विद्यार्थी उपस्थिती / डाउनलोड करा</div></div>}
                                    className="button-global button-primary autoWidth autoHeight"
                                    onClick={this.generatePDF} />
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    };
}

export default NewAttendanceSheet;